module.exports = __webpack_public_path__ + "img/网上商城 在线下单更方便.16f7eb82.png";